export default {
  APP_ROOT_PATH: '/',
  //APP_ROOT_PATH:'/tpl/',
  //API_URL: 'https://localhost:44331',
  // API_URL: 'http://localhost:8081',
  API_URL: 'https://lms-api.careerlibrary.sg'
}